import type { ClanNotifType } from '@/clan/clanApi';
import type { I18nKey } from '@/i18n/translations';

type TFn = (key: I18nKey, vars?: Record<string, string | number>) => string;

/** Render a clan notification into an icon + a single localized line, shared by
 * the live toast (ClanNotifier) and the inbox list (ClanScreen). */
export function clanNotifText(
  type: ClanNotifType,
  data: Record<string, unknown>,
  t: TFn,
): { icon: string; text: string } {
  const clan = String(data.clan ?? '');
  const name = String(data.requesterName ?? '');
  const roleKey = `clan.role.${String(data.role ?? 'member')}` as I18nKey;
  switch (type) {
    case 'join_request':
      return { icon: '👋', text: t('clan.notif.join_request', { name, clan }) };
    case 'join_approved':
      return { icon: '✅', text: t('clan.notif.join_approved', { clan }) };
    case 'join_rejected':
      return { icon: '🚫', text: t('clan.notif.join_rejected', { clan }) };
    case 'kicked':
      return { icon: '⚠️', text: t('clan.notif.kicked', { clan }) };
    case 'role_changed':
      return { icon: '⭐', text: t('clan.notif.role_changed', { clan, role: t(roleKey) }) };
    case 'war_scheduled':
      return { icon: '⚔️', text: t('clan.notif.war_scheduled', { clan }) };
    case 'war_open':
      return { icon: '⚔️', text: t('clan.notif.war_open', { clan }) };
    case 'war_ended':
      return {
        icon: '🏁',
        text: t('clan.notif.war_ended', { clan, result: t(`clan.notif.result_${String(data.result ?? 'draw')}` as I18nKey) }),
      };
    case 'emblem_awarded':
      return { icon: '🏆', text: t('clan.notif.emblem_awarded', { rank: String(data.rank ?? ''), name: String(data.emblem ?? '') }) };
    default:
      return { icon: '🔔', text: '' };
  }
}
